import HttpResponse from "../../../../../utils/http/http.response";

export enum OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceType {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
}

export type OrderCargoOrderDetailsResponseItemDriver = {
  id: string;
  firstName: string;
  lastName: string;
  mobilePrimaryPrefix: string;
  mobilePrimary: string;
};

export type OrderCargoOrderDetailsResponseItemPassengerDataPassengerAddressData =
  {
    id: string;
    displayName: string;
    lat: number;
    lon: number;
    apartment?: string;
    houseNo?: string;
    street?: string;
    town?: string;
    zipcode?: string;
  };

export type OrderCargoOrderDetailsResponseItemPassengerDataPassenger = {
  addresses: OrderCargoOrderDetailsResponseItemPassengerDataPassengerAddressData[];
};

export type OrderCargoOrderDetailsResponseItemPassenger = {
  id: string;
  lastName: string;
  firstName: string;
  passenger: OrderCargoOrderDetailsResponseItemPassengerDataPassenger;
};

export type OrderCargoOrderDetailsResponseItemCargoOrderMeta = {
  id: string;
};

export type OrderCargoOrderDetailsResponseItemCargoOrderRideMetaCargoSubject = {
  id: string;
};

export type OrderCargoOrderDetailsResponseItemCargoOrderRideMetaCargoSubjectList =
  {
    subjects: OrderCargoOrderDetailsResponseItemCargoOrderRideMetaCargoSubject[];
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderRideMeta =
  OrderCargoOrderDetailsResponseItemCargoOrderMeta & {
    cargoEnter: OrderCargoOrderDetailsResponseItemCargoOrderRideMetaCargoSubjectList;
    cargoExit: OrderCargoOrderDetailsResponseItemCargoOrderRideMetaCargoSubjectList;
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderRideSeqNode = {
  lat: number;
  lon: number;
  time: Date | null;
  haltingTime: number;
  meta: OrderCargoOrderDetailsResponseItemCargoOrderRideMeta;
  displayName: string;
  apartment?: string;
  houseNo?: string;
  street?: string;
  town?: string;
  zipCode?: string;
};

export type OrderCargoOrderDetailsResponseItemCargoOrderRideSeqNodeSet = {
  seq: OrderCargoOrderDetailsResponseItemCargoOrderRideSeqNode[];
  meta: OrderCargoOrderDetailsResponseItemCargoOrderMeta;
  sequenceOrder: "ANY";
};

export type OrderCargoOrderDetailsResponseItemCargoOrderRideSeq = (
  | OrderCargoOrderDetailsResponseItemCargoOrderRideSeqNode
  | OrderCargoOrderDetailsResponseItemCargoOrderRideSeqNodeSet
)[];

export type OrderCargoOrderDetailsResponseItemCargoOrderRide = {
  seq: OrderCargoOrderDetailsResponseItemCargoOrderRideSeq;
  meta: OrderCargoOrderDetailsResponseItemCargoOrderMeta;
  sequenceOrder: "STRICT";
};

export type OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceInternal = {
  sourceType: OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceType.INTERNAL;
  externalId?: string;
};

export type OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceExternal = {
  sourceType: OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceType.EXTERNAL;
  externalId?: string;
  firstName: string;
  lastName: string;
  phoneNo: string;
  dispatchName?: string;
};

export type OrderCargoOrderDetailsResponseItemCargoOrderCargoSource =
  | OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceInternal
  | OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceExternal;

export type OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceElement = {
  cargoSubjectId: string;
  cargoItemSource: OrderCargoOrderDetailsResponseItemCargoOrderCargoSource;
};

export type OrderCargoOrderDetailsResponseItemCargoOrderDispatcherDispatchCargoCompany =
  {
    id: string;
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderDispatcherDispatch = {
  cargoCompany: OrderCargoOrderDetailsResponseItemCargoOrderDispatcherDispatchCargoCompany;
};

export type OrderCargoOrderDetailsResponseItemCargoOrderDispatcher = {
  dispatch: OrderCargoOrderDetailsResponseItemCargoOrderDispatcherDispatch;
};

export type OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubject =
  {
    id: string;
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjectList =
  {
    subjects: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubject[];
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMeta =
  {
    cargoEnter: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjectList;
    cargoExit: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMetaSubjectList;
    estimatedTime: string;
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItem =
  {
    lat: number;
    lon: number;
    time: string | null;
    haltingTime: number;
    displayName: string;
    meta: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItemMeta;
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRide =
  {
    seq: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRideSeqItem[];
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrder =
  {
    ride: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrderRide;
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderCreatePlanEntryDriver =
  {
    id: string;
    firstName: string;
    lastName: string;
    mobilePrimaryPrefix: string;
    mobilePrimary: string;
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderCreatePlanEntry =
  {
    driver: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderCreatePlanEntryDriver;
  };

export type OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrder = {
  solvedOrder: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderSolvedOrder | null;
  createPlanEntryEntries: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrderCreatePlanEntry[];
};

export type OrderCargoOrderDetailsResponseItemCargoOrder = {
  id: string;
  humanId: number;
  ride: OrderCargoOrderDetailsResponseItemCargoOrderRide;
  transportingOrders: OrderCargoOrderDetailsResponseItemCargoOrderTransportingOrder[];
  cargoItemsSourceList: OrderCargoOrderDetailsResponseItemCargoOrderCargoSourceElement[];
  dispatcher: OrderCargoOrderDetailsResponseItemCargoOrderDispatcher;
};

export type OrderCargoOrderDetailsResponseItemNodeExclusion = {
  excludeApproaching: boolean;
  excludeInside: boolean;
  excludeReturning: boolean;
};

export type OrderCargoOrderDetailsResponseItem = {
  id: string;
  passengers: OrderCargoOrderDetailsResponseItemPassenger[];
  drivers: OrderCargoOrderDetailsResponseItemDriver[];
  cargoOrder: OrderCargoOrderDetailsResponseItemCargoOrder;
  forceAllowToll: boolean;
  nodeExclusion: OrderCargoOrderDetailsResponseItemNodeExclusion;
};

type OrderCargoOrderDetailsResponse =
  HttpResponse<OrderCargoOrderDetailsResponseItem>;

export default OrderCargoOrderDetailsResponse;
